<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <div class="w-full max-w-[420px] px-10 pt-6 pb-10">
    <div class="mb-5 text-center">
      <h3 class="text-lg font-bold">{{ t.title }}</h3>
    </div>

    <p class="mb-6 text-center text-sm/relaxed whitespace-pre-line">
      {{ t.description }}
    </p>

    <div class="flex justify-center">
      <NordyButton
        button-style="primary"
        class-name="px-5 py-2 text-sm border-none font-bold"
        @click="onContinue"
      >
        {{ t.cta }}
      </NordyButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import NordyButton from '@/nordy/components/NordyButton.vue'
import { useNordyUserStore } from '@/nordy/store/nordyUserStore'
import { useDialogStore } from '@/stores/dialogStore'

const nordyUserStore = useNordyUserStore()

const texts = {
  ko: {
    title: '구독 혜택이 종료되었어요',
    description:
      '제공받으신 구독 혜택이 만료되었습니다.\n\nNordy는 계속 사용할 수 있지만, 구독을 시작하면 더 많은 크레딧과 구독 혜택으로 작업을 더 안정적으로 이어갈 수 있어요.',
    cta: '구독 혜택 이어가기'
  },
  en: {
    title: 'Your subscription benefits have ended',
    description:
      'The subscription benefits you received have expired.\n\nYou can still use Nordy, but starting a subscription gives you more credits and subscription benefits to help you continue your work more reliably.',
    cta: 'Continue Subscription Benefits'
  }
}

const t = computed(() =>
  nordyUserStore.nordyUser?.language === 'ko' ? texts.ko : texts.en
)

const dialogStore = useDialogStore()

function onContinue() {
  window.open('/pricing', '_blank')
  dialogStore.closeDialog({ key: 'nordy-coupon-expired' })
}
</script>
